export default "__VITE_ASSET__DV4D6ArZ__"